import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "21", y1: "6", y2: "6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 12h15a3 3 0 1 1 0 6h-4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "16 16 14 18 16 20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "3", x2: "10", y1: "18", y2: "18", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "WrapText";
const WrapText = memo(themed(Icon));
export {
  WrapText
};
//# sourceMappingURL=wrap-text.js.map
